import { useAreas, usePartnerCustomers } from '@hooks';
import { Area } from '@modules/clients/modules/CompanyDetails/components/AreasList/AreasList';
interface Company {
  id: number;
  legalName: string;
  legalIdentification: string;
  fkCustomerGroup: number | null;
}
export const FIELDS = [
  {
    name: 'firstName',
    label: 'COMMON:FIRST_NAME',
    type: 'input',
    getOptions: () => {},
    parseOption: () => {},
  },
  {
    name: 'lastName',
    label: 'COMMON:LAST_NAME',
    type: 'input',
    getOptions: () => {},
    parseOption: () => {},
  },
  {
    name: 'email',
    label: 'COMMON:EMAIL',
    type: 'input',
    getOptions: () => {},
    parseOption: () => {},
  },
  {
    name: 'customers',
    label: 'COMMON:COMPANY',
    getOptions: usePartnerCustomers,
    type: 'autocomplete',
    parseOption: (item: Company) => ({ text: item?.legalName, value: item?.id?.toString() }),
  },
  {
    name: 'areaIds',
    label: 'COMMON:AREA',
    getOptions: useAreas,
    type: 'autocomplete',
    parseOption: (item: Area) => ({
      text: item?.name,
      value: item?.id,
    }),
  },
] as const;
